import React from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';
import Button from 'react-bootstrap/Button';

export default (props) => {
  const {
    path, children, variant, size, className
  } = props;

  const htmlAttrs = {};
  
  if (path && path.includes("/consulter")) {
    htmlAttrs["rel"] = "nofollow";
  }

  return (
    <Link to={path} {...htmlAttrs}>
      <Button variant={variant} size={size} className="cta-consulter-landing">
        <span {...props} className={cx('', className)}>{children}</span>
      </Button>
    </Link>
  );
};
